import {toJson} from '../../../core/data-source/json.mapper';
import {httpService} from '../../../core/services/http.service';
import {BulkChangeRecord} from './bulk-change.record';

export class BulkChangeDataSource<T> {
    protected apiPath: string = '/gt/gt-api/journeys/bulk-change?saveAsDefault=';

    async save(data: BulkChangeRecord, saveAsDefault: boolean): Promise<BulkChangeRecord> {
        return await httpService.post(this.apiPath + saveAsDefault.toString(), toJson(data));
    }
}
